// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

body {
    height: 100vh;
    display: grid;
    grid-template-rows: 1fr 6fr;
    grid-template-columns: 1fr 4.5fr;
    gap: 3em;

    font-family: lato, Roboto, sans-serif;
    padding: 0px 3em;
    margin: 0px;
}

header {
    grid-area: 1/1/2/3;
    display: flex;
    height: 90%;
    justify-content: space-around;
    gap: 100px;
    border: solid 2px black;
    border-radius: 8px;
    padding: 0px 1em;
    margin-top: 1.5em;
}

ul {
    list-style: none;
}

.title-ctr {
    display: flex;
    align-items: center;

    margin-right: -90px;

}

.title-ctr>img {
    width: 5%
}

header>img {
    flex-shrink: 0;
    margin-right: auto;
    width: 3%;
    cursor: pointer;
}

h2 {
    margin: 0px;
}

nav,
.app-ctr {
    border: solid 2px black;
    border-radius: 8px;
    margin-bottom: 1.5em;

    padding: 1em 1em;
    transition: 6s;
}

.close-nav-body {
    grid-template-columns: 1fr;
}

.close-nav {
    display: none;
}

.close-nav-app-ctr {
    grid-area: 2/1/3/3;
}

nav ul {
    padding-left: 10px;
    cursor: pointer;
}

.project-list img {
    width: 10%;
    cursor: pointer;
}

.project-list-item {
    display: flex;
    justify-content: space-between;
}

.home-div li {

    display: flex;

}

#inbox {
    padding: 0px;
    margin: 0px;
}

.project-delete:hover,
.home-div>ul:hover #inbox,
.project-list-item:hover span {
    transform: scale(1.3);
}


.add-project-form {
    display: flex;
    flex-direction: column;
    gap: 1em;

    border: solid 1px black;
    padding: .5em;

    border-radius: 8px;
}

.add-project-form button {
    cursor: pointer;
}

.project-title {
    line-height: 2em;
    padding: 0px .4em;
}

.project-btn-ctr {
    display: flex;
    justify-content: flex-end;
    gap: .8em;
}

/*task list*/
.task-list {
    width: 100%;
    padding: 0;
}

.task-ctr {
    width: 100%;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: .5fr 4fr 1fr 1fr 1fr;
    align-items: center;
    cursor: pointer;
    padding: 0;
    border-left: 10px white solid;
}

.task-ctr:hover {
    border-left-color: black;
}

.task-ctr li {
    flex: 0 1 0;
}

.task-delete,
.task-edit {
    justify-self: center;
}

.task-description {
    overflow: hidden;
    height: 0;
    padding: 0 1em 0 3.3em;
}

.task-description-open {
    padding: 1em 1em 2em 3.3em;
    height: initial;
}


.task-ctr img {
    width: 4rem;
    cursor: pointer;
}

/* Add task form */
.add-task-form,
.edit-task-form {
    grid-area: 1/1/2/6;
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 1.2em;

    border: solid 1.5px black;
    padding: .8em;

    border-radius: 8px;
}

form .task-title {
    height: 2.5em;
    width: 100%;
}

form .description-input {
    height: 9em;
    width: 100%;

}

.form-div {
    display: flex;
    justify-content: space-between;
}


label>* {

    display: block;
    margin-top: .3em;
}

/* Radio buttion styling for task form*/
.radio-ctr {
    float: left;
    margin: 0 5px 0 0;
    width: 3.5em;
    height: 2em;
    position: relative;


}

.radio-label,
.task-priority {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.task-priority {
    opacity: 0.011;
    z-index: 100;
    cursor: pointer;
}

.task-priority:checked+label {
    color: aliceblue;
    border-radius: 4px;
}

#low-priority:checked+label {
    background: #4fab5c;

}

#med-priority:checked+label {
    background: #e6d732;

}

#high-priority:checked+label {
    background: #db240f;

}

.radio-label {

    z-index: 90;
    line-height: 1.8em;
    display: flex;
    justify-content: center;
}

/*task form buttons*/
.task-btn-ctr {
    display: flex;
    gap: 2em;
    align-self: flex-end;
}

.task-btn {
    height: 3em;
    width: 5em;
}`, "",{"version":3,"sources":["webpack://./style.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,gCAAgC;IAChC,QAAQ;;IAER,qCAAqC;IACrC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,mBAAmB;;AAEvB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;;IAEpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;;AAEjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;;IAGI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER,uBAAuB;IACvB,aAAa;;IAEb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;;IAEI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,UAAU;;IAEV,yBAAyB;IACzB,aAAa;;IAEb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;;AAGA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;;;AAGtB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,UAAU;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    height: 100vh;\n    display: grid;\n    grid-template-rows: 1fr 6fr;\n    grid-template-columns: 1fr 4.5fr;\n    gap: 3em;\n\n    font-family: lato, Roboto, sans-serif;\n    padding: 0px 3em;\n    margin: 0px;\n}\n\nheader {\n    grid-area: 1/1/2/3;\n    display: flex;\n    height: 90%;\n    justify-content: space-around;\n    gap: 100px;\n    border: solid 2px black;\n    border-radius: 8px;\n    padding: 0px 1em;\n    margin-top: 1.5em;\n}\n\nul {\n    list-style: none;\n}\n\n.title-ctr {\n    display: flex;\n    align-items: center;\n\n    margin-right: -90px;\n\n}\n\n.title-ctr>img {\n    width: 5%\n}\n\nheader>img {\n    flex-shrink: 0;\n    margin-right: auto;\n    width: 3%;\n    cursor: pointer;\n}\n\nh2 {\n    margin: 0px;\n}\n\nnav,\n.app-ctr {\n    border: solid 2px black;\n    border-radius: 8px;\n    margin-bottom: 1.5em;\n\n    padding: 1em 1em;\n    transition: 6s;\n}\n\n.close-nav-body {\n    grid-template-columns: 1fr;\n}\n\n.close-nav {\n    display: none;\n}\n\n.close-nav-app-ctr {\n    grid-area: 2/1/3/3;\n}\n\nnav ul {\n    padding-left: 10px;\n    cursor: pointer;\n}\n\n.project-list img {\n    width: 10%;\n    cursor: pointer;\n}\n\n.project-list-item {\n    display: flex;\n    justify-content: space-between;\n}\n\n.home-div li {\n\n    display: flex;\n\n}\n\n#inbox {\n    padding: 0px;\n    margin: 0px;\n}\n\n.project-delete:hover,\n.home-div>ul:hover #inbox,\n.project-list-item:hover span {\n    transform: scale(1.3);\n}\n\n\n.add-project-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n\n    border: solid 1px black;\n    padding: .5em;\n\n    border-radius: 8px;\n}\n\n.add-project-form button {\n    cursor: pointer;\n}\n\n.project-title {\n    line-height: 2em;\n    padding: 0px .4em;\n}\n\n.project-btn-ctr {\n    display: flex;\n    justify-content: flex-end;\n    gap: .8em;\n}\n\n/*task list*/\n.task-list {\n    width: 100%;\n    padding: 0;\n}\n\n.task-ctr {\n    width: 100%;\n    display: grid;\n    grid-template-rows: 1fr;\n    grid-template-columns: .5fr 4fr 1fr 1fr 1fr;\n    align-items: center;\n    cursor: pointer;\n    padding: 0;\n    border-left: 10px white solid;\n}\n\n.task-ctr:hover {\n    border-left-color: black;\n}\n\n.task-ctr li {\n    flex: 0 1 0;\n}\n\n.task-delete,\n.task-edit {\n    justify-self: center;\n}\n\n.task-description {\n    overflow: hidden;\n    height: 0;\n    padding: 0 1em 0 3.3em;\n}\n\n.task-description-open {\n    padding: 1em 1em 2em 3.3em;\n    height: initial;\n}\n\n\n.task-ctr img {\n    width: 4rem;\n    cursor: pointer;\n}\n\n/* Add task form */\n.add-task-form,\n.edit-task-form {\n    grid-area: 1/1/2/6;\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    gap: 1.2em;\n\n    border: solid 1.5px black;\n    padding: .8em;\n\n    border-radius: 8px;\n}\n\nform .task-title {\n    height: 2.5em;\n    width: 100%;\n}\n\nform .description-input {\n    height: 9em;\n    width: 100%;\n\n}\n\n.form-div {\n    display: flex;\n    justify-content: space-between;\n}\n\n\nlabel>* {\n\n    display: block;\n    margin-top: .3em;\n}\n\n/* Radio buttion styling for task form*/\n.radio-ctr {\n    float: left;\n    margin: 0 5px 0 0;\n    width: 3.5em;\n    height: 2em;\n    position: relative;\n\n\n}\n\n.radio-label,\n.task-priority {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.task-priority {\n    opacity: 0.011;\n    z-index: 100;\n    cursor: pointer;\n}\n\n.task-priority:checked+label {\n    color: aliceblue;\n    border-radius: 4px;\n}\n\n#low-priority:checked+label {\n    background: #4fab5c;\n\n}\n\n#med-priority:checked+label {\n    background: #e6d732;\n\n}\n\n#high-priority:checked+label {\n    background: #db240f;\n\n}\n\n.radio-label {\n\n    z-index: 90;\n    line-height: 1.8em;\n    display: flex;\n    justify-content: center;\n}\n\n/*task form buttons*/\n.task-btn-ctr {\n    display: flex;\n    gap: 2em;\n    align-self: flex-end;\n}\n\n.task-btn {\n    height: 3em;\n    width: 5em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
